export const links = {
    facebook: 'https://www.facebook.com/YourModule',
    linkedin: 'https://www.linkedin.com/company/yourmodule/',
    twitter: 'https://twitter.com/ModuleLLC',
    instagram: 'https://www.instagram.com/yourmodule/',
    youtube: 'https://www.youtube.com/@yourmodule',
}
